/* Dulzar — lógica de la tienda en Shopify.
   Carta por categorías, tamaños, selector de gustos (con recargos por gusto premium/Nutella),
   carrito lateral sobre el carrito real de Shopify (/cart.js), "Para cuántos", horario de Lima,
   cabecera, animaciones y página con contraseña. Sin librerías externas. */
(function () {
  "use strict";
  const DZ = window.DZ = window.DZ || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const fine = window.matchMedia("(pointer: fine)").matches;
  // Mismo formato de precio que la tienda (Configuración → General → Moneda), ej. "S/. {{amount}}"
  const money = cents => {
    const fmt = DZ.moneda || "S/ {{amount}}", v = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => k.includes("comma") ? v.replace(".", ",") : k.includes("no_decimals") ? String(Math.round(cents / 100)) : v);
  };
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
  };
  const ML = window.ML;

  /* ================= ilustraciones ================= */
  function ilustraciones(scope) {
    if (!ML) return;
    const defs = $("#mldefs"); if (defs && !defs.innerHTML) defs.innerHTML = ML.defs();
    $$("[data-dz-sun]", scope).forEach(s => { if (!s.innerHTML) s.innerHTML = `<g>${ML.sun()}</g>`; });
    $$("[data-dz-medialuna]", scope).forEach(s => {
      if (s.innerHTML) return;
      const v = s.getAttribute("data-dz-medialuna") || "clasica";
      s.innerHTML = s.hasAttribute("data-dz-grande") ? ML.one({ variant: v, seed: 11, gloss: 1.3 }) : ML.one({ variant: v, seed: 4, shadow: false });
    });
    $$("[data-dz-caja]", scope).forEach(s => { if (!s.innerHTML) s.innerHTML = ML.box({ variant: s.getAttribute("data-dz-caja"), count: 6, seed: 3 }); });
    const eb = $("#emptyBox"); if (eb && !eb.innerHTML) eb.innerHTML = ML.box({ variant: "clasica", count: 6, seed: 3 });
    $$("[data-dz-mapa]", scope).forEach(m => {
      if (m.innerHTML) return;
      let s = `<rect width="600" height="400" fill="#17402F"/><g transform="rotate(-16 300 200)" stroke="#FBEBD3" stroke-linecap="round" opacity=".14">`;
      for (let x = -200; x < 900; x += 64) s += `<line x1="${x}" y1="-200" x2="${x}" y2="700" stroke-width="${x % 192 === 56 ? 14 : 5}"/>`;
      for (let y = -200; y < 700; y += 52) s += `<line x1="-200" y1="${y}" x2="900" y2="${y}" stroke-width="${y % 156 === 112 ? 12 : 4}"/>`;
      s += `</g><path d="M-20 330 C 120 300, 210 360, 330 300 S 520 250, 640 280" fill="none" stroke="#235640" stroke-width="26" opacity=".9"/>`;
      s += `<g transform="translate(395 120)"><circle r="46" fill="#E3A140" opacity=".25">${reduce ? "" : `<animate attributeName="r" values="30;56;30" dur="2.6s" repeatCount="indefinite"/><animate attributeName="opacity" values=".45;0;.45" dur="2.6s" repeatCount="indefinite"/>`}</circle><circle r="30" fill="#FBEBD3"/><g transform="scale(.26) translate(0 4)">${ML.one({ variant: "clasica", seed: 8, shadow: false })}</g></g>`;
      m.innerHTML = s;
    });
  }

  /* ================= horario (hora de Lima) ================= */
  const DIAS = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
  const toMin = t => { const m = String(t || "").trim().match(/^(\d{1,2})[:.](\d{2})/); return m ? +m[1] * 60 + +m[2] : null; };
  const hhmm = m => { const h = Math.floor(m / 60) % 24; return `${h % 12 || 12}:${String(m % 60).padStart(2, "0")} ${h < 12 ? "a. m." : "p. m."}`; };
  function horario() {
    const h = {};
    (DZ.horario || []).forEach(l => {
      const [dia, a, c] = String(l).split("|").map(x => (x || "").trim());
      const i = DIAS.findIndex(d => d.toLowerCase() === (dia || "").toLowerCase());
      const o = toMin(a), cl = toMin(c);
      if (i >= 0 && o !== null && cl !== null) h[i] = [o, cl];
    });
    return h;
  }
  function limaNow() {
    const parts = new Intl.DateTimeFormat("en-US", { timeZone: "America/Lima", weekday: "short", hour: "2-digit", minute: "2-digit", hour12: false }).formatToParts(new Date());
    const g = t => parts.find(p => p.type === t).value;
    return { day: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].indexOf(g("weekday")), min: (parseInt(g("hour"), 10) % 24) * 60 + parseInt(g("minute"), 10) };
  }
  function estado(H) {
    const { day, min } = limaNow();
    const hoy = H[day];
    if (hoy && min >= hoy[0] && min < hoy[1]) return { open: true, text: `Abierto · cierra ${hhmm(hoy[1])}`, big: "Abierto", small: `hoy hasta las ${hhmm(hoy[1])}` };
    if (hoy && min < hoy[0]) return { open: false, text: `Cerrado · abre hoy ${hhmm(hoy[0])}`, big: hhmm(hoy[0]), small: "abrimos hoy" };
    for (let k = 1; k <= 7; k++) {
      const d = (day + k) % 7;
      if (H[d]) return { open: false, text: `Cerrado · abre ${k === 1 ? "mañana" : DIAS[d].toLowerCase()} ${hhmm(H[d][0])}`, big: hhmm(H[d][0]), small: k === 1 ? "abrimos mañana" : `abrimos el ${DIAS[d].toLowerCase()}` };
    }
    return null;
  }
  function pintarHorario() {
    const H = horario();
    if (!Object.keys(H).length) return;
    const st = estado(H); if (!st) return;
    const { day } = limaNow();
    const hs = $("#hdrStatus"); if (hs) { $("span", hs).textContent = st.text; hs.classList.toggle("closed", !st.open); }
    $$("[data-dz-now]").forEach(n => { $("span", n).textContent = st.text; n.classList.toggle("closed", !st.open); });
    const hero = $("#heroStatus"); if (hero) hero.innerHTML = `<b>${st.big}</b><span>${st.small}</span>`;
    $$("[data-dz-horas]").forEach(tb => {
      tb.innerHTML = [1, 2, 3, 4, 5, 6, 0].map(d => `<tr class="${d === day ? "today" : ""}"><td>${DIAS[d]}</td><td>${H[d] ? `${hhmm(H[d][0])} – ${hhmm(H[d][1])}` : "Cerrado"}</td></tr>`).join("");
    });
  }

  /* ================= aviso y animación de "vuelo" al carrito ================= */
  let tt;
  function toast(m) { const t = $("#toast"); if (!t) return; t.textContent = m; t.classList.add("on"); clearTimeout(tt); tt = setTimeout(() => t.classList.remove("on"), 1900); }
  function bump() { [$("#cartBtn"), $("#mbar button")].forEach(t => { if (!t) return; t.classList.remove("bump"); void t.offsetWidth; t.classList.add("bump"); }); }
  function fly(fromEl, variant) {
    if (reduce || !fromEl || !document.body.animate || !ML) { bump(); return; }
    const mb = $("#mbar");
    const target = window.innerWidth < 960 && mb && mb.classList.contains("on") ? $("#mbar button") : $("#cartBtn");
    if (!target) return;
    const hdr = $("#hdr"); if (hdr) hdr.classList.remove("hide");
    const a = fromEl.getBoundingClientRect(), b = target.getBoundingClientRect();
    const el = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    el.setAttribute("viewBox", "-100 -64 200 128"); el.setAttribute("aria-hidden", "true"); el.classList.add("fly");
    el.innerHTML = ML.one({ variant: variant || "clasica", seed: 2, shadow: false });
    const host = $(".dz") || document.body; host.appendChild(el);
    const x0 = a.left + a.width / 2 - 35, y0 = a.top + a.height / 2 - 22, x1 = b.left + b.width / 2 - 35, y1 = b.top + b.height / 2 - 22;
    const mx = (x0 + x1) / 2, my = Math.min(y0, y1) - 140;
    el.animate([
      { transform: `translate(${x0}px,${y0}px) scale(.6)`, opacity: 0 },
      { transform: `translate(${x0}px,${y0 - 30}px) scale(1.25) rotate(-20deg)`, opacity: 1, offset: .18 },
      { transform: `translate(${mx}px,${my}px) scale(1) rotate(140deg)`, offset: .6 },
      { transform: `translate(${x1}px,${y1}px) scale(.35) rotate(320deg)`, opacity: .9 },
    ], { duration: 820, easing: "cubic-bezier(.45,.05,.4,1)" }).onfinish = () => { el.remove(); bump(); };
  }

  /* ================= carrito (API de Shopify) ================= */
  let cart = null;
  async function api(path, body) {
    const r = await fetch(root + path, body ? { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) } : { headers: { Accept: "application/json" } });
    const j = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(j.description || j.message || "No pudimos actualizar tu pedido.");
    return j;
  }
  async function cargarCarrito() { cart = await api("cart.js"); pintarCarrito(); return cart; }
  async function agregar(items, fromEl, variant, mensaje) {
    try {
      await api("cart/add.js", { items });
      await cargarCarrito();
      fly(fromEl, variant);
      if (mensaje) toast(mensaje);
      return true;
    } catch (e) { toast(e.message); return false; }
  }
  const esRecargo = it => it.properties && it.properties._recargo;
  function grupos() {
    const cajas = [], recargos = {};
    (cart ? cart.items : []).forEach((it, idx) => {
      it._line = idx + 1;
      if (esRecargo(it)) { const g = it.properties._grupo || "suelto"; (recargos[g] = recargos[g] || []).push(it); }
      else cajas.push(it);
    });
    return { cajas, recargos };
  }
  function pintarCarrito() {
    if (!cart) return;
    const { cajas, recargos } = grupos();
    const count = cajas.reduce((s, i) => s + i.quantity, 0);
    const cc = $("#cartCount"); if (cc) cc.textContent = count;
    const mb = $("#mbar");
    if (mb) {
      mb.classList.toggle("on", count > 0);
      $("#mbarTxt").textContent = count ? `Ver pedido · ${count} ${count === 1 ? "caja" : "cajas"}` : "Ver tu pedido";
      $("#mbarTot").textContent = money(cart.total_price);
    }
    const empty = !cajas.length;
    const e = $("#empty"); if (!e) return;
    e.hidden = !empty; $("#orderForm").hidden = empty; $("#drFoot").hidden = empty;
    $("#items").innerHTML = cajas.map(it => {
      const g = it.properties && it.properties._grupo;
      const extras = (g && recargos[g]) || [];
      const extraTot = extras.reduce((s, r) => s + r.final_line_price, 0);
      const gustos = it.properties && it.properties.Gustos;
      const img = it.image ? it.image + (it.image.includes("?") ? "&" : "?") + "width=160" : "";
      return `<li class="item" data-key="${it.key}">
        ${img ? `<img class="thumb" src="${img}" alt="" width="72" height="48">` : `<span class="thumb"></span>`}
        <span class="nm">${it.product_title}<small>${it.variant_title && it.variant_title !== "Default Title" ? it.variant_title + " · " : ""}${money(it.final_price)}</small>${gustos ? `<small class="fl">${gustos}</small>` : ""}${extraTot ? `<small class="ex">Incluye recargo de gustos: ${money(extraTot)}</small>` : ""}</span>
        <div class="qty"><button type="button" data-q="-1" aria-label="Quitar una caja de ${it.product_title}">−</button><span>${it.quantity}</span><button type="button" data-q="1" aria-label="Agregar una caja de ${it.product_title}">+</button></div>
        <div class="lt"><span>${it.quantity} ${it.quantity === 1 ? "caja" : "cajas"}</span><span>${money(it.final_line_price + extraTot)}</span></div>
      </li>`;
    }).join("");
    $("#subT").textContent = money(cart.total_price);
    const n = $("#notes"); if (n && document.activeElement !== n && cart.note != null) n.value = cart.note;
  }
  async function cambiarCaja(key, delta) {
    const { cajas, recargos } = grupos();
    const it = cajas.find(c => c.key === key); if (!it) return;
    const nueva = Math.max(0, it.quantity + delta);
    const updates = { [key]: nueva };
    const g = it.properties && it.properties._grupo;
    (g && recargos[g] || []).forEach(r => { const porCaja = Math.round(r.quantity / it.quantity); updates[r.key] = porCaja * nueva; });
    try { cart = await api("cart/update.js", { updates }); pintarCarrito(); }
    catch (e) { toast(e.message); }
  }

  /* panel lateral */
  let lastFocus = null;
  const lock = on => { document.documentElement.style.overflow = on ? "hidden" : ""; };
  function abrirPedido() {
    cerrarMenu();
    lastFocus = document.activeElement;
    const d = $("#drawer"); if (!d) return;
    d.classList.add("on"); $("#scrim").classList.add("on"); d.setAttribute("aria-hidden", "false"); lock(true);
    opcionesCuando();
    cargarCarrito().catch(() => {});
    setTimeout(() => $("#drClose").focus(), 60);
  }
  function cerrarPedido() {
    const d = $("#drawer"); if (!d) return;
    d.classList.remove("on"); $("#scrim").classList.remove("on"); d.setAttribute("aria-hidden", "true"); lock(false);
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
  }
  function opcionesCuando() {
    const sel = $("#when"); if (!sel) return;
    const H = horario(); const { day, min } = limaNow();
    const opts = ["Lo antes posible"];
    if (H[day]) { const [o, c] = H[day]; for (let m = Math.max(o + 30, Math.ceil((min + 60) / 30) * 30); m <= c - 30; m += 30) opts.push(`Hoy ${hhmm(m)}`); }
    const nd = (day + 1) % 7; if (H[nd]) { const [o2, c2] = H[nd]; for (let m = o2 + 30; m <= Math.min(c2 - 30, o2 + 30 + 300); m += 30) opts.push(`Mañana ${hhmm(m)}`); }
    const prev = sel.value || (cart && cart.attributes && cart.attributes["Para cuándo"]);
    sel.innerHTML = opts.map(x => `<option>${x}</option>`).join("");
    if (opts.includes(prev)) sel.value = prev;
  }
  async function irAPagar() {
    const btn = $("#payBtn"), err = $("#payErr");
    btn.disabled = true; $("#payTxt").textContent = "Un momento…"; err.hidden = true;
    try {
      await api("cart/update.js", { note: $("#notes").value.trim(), attributes: { "Para cuándo": $("#when").value } });
      window.location.href = root + "checkout";
    } catch (e) {
      err.textContent = e.message; err.hidden = false;
      btn.disabled = false; $("#payTxt").textContent = (DZ.textos && DZ.textos.pagar) || "Ir a pagar";
    }
  }

  /* ================= la carta ================= */
  function datos(card) { try { return JSON.parse($("[data-dz-producto]", card).textContent); } catch (e) { return null; } }
  const variante = (p, id) => p.variants.find(v => v.id === +id) || p.variants[0];
  function placePill(seg) {
    const on = seg && seg.querySelector('[aria-pressed="true"]'), pill = seg && seg.querySelector(".pill");
    if (!on || !pill) return;
    pill.style.width = on.offsetWidth + "px"; pill.style.transform = `translateX(${on.offsetLeft - 4}px)`;
  }
  const pills = () => $$(".dz .seg").forEach(placePill);
  function tweenPrecio(el, from, to) {
    if (reduce || from === to) { el.textContent = money(to); return; }
    const t0 = performance.now(), d = 450;
    (function f(t) { const k = Math.min(1, (t - t0) / d), e = 1 - Math.pow(1 - k, 3); el.textContent = money(Math.round(from + (to - from) * e)); if (k < 1) requestAnimationFrame(f); })(t0);
  }
  function porUnidad(card, v) { const per = $("[data-per]", card); if (per) per.textContent = v.size > 1 ? `${money(Math.round(v.price / v.size))} c/u` : ""; }
  function iniciarCarta() {
    $$("[data-dz-tabs]").forEach(tabs => {
      tabs.addEventListener("click", e => {
        const b = e.target.closest('[role="tab"]'); if (!b) return;
        $$('[role="tab"]', tabs).forEach(t => { const on = t === b; t.setAttribute("aria-selected", on); t.setAttribute("aria-pressed", on); const p = document.getElementById(t.getAttribute("aria-controls")); if (p) p.hidden = !on; });
        requestAnimationFrame(pills);
      });
    });
    $$("[data-dz-card]").forEach(card => {
      const p = datos(card); if (!p) return;
      card._p = p;
      const seg = $(".seg", card);
      card._v = variante(p, seg && ($('[aria-pressed="true"]', seg) || {}).dataset ? $('[aria-pressed="true"]', seg).dataset.v : p.variants[0].id);
      porUnidad(card, card._v);
      if (seg) seg.addEventListener("click", e => {
        const b = e.target.closest("button[data-v]"); if (!b || b.disabled) return;
        const v = variante(p, b.dataset.v); if (v.id === card._v.id) return;
        const prev = card._v; card._v = v;
        $$("button[data-v]", seg).forEach(x => x.setAttribute("aria-pressed", x === b));
        placePill(seg);
        tweenPrecio($(".pv", card), prev.price, v.price);
        porUnidad(card, v);
        const u = $(".units", card); if (u) u.textContent = v.title;
        if (v.img && v.img !== prev.img) {
          const swap = $(".swap", card), old = swap.firstElementChild;
          const nw = new Image(); nw.className = "pimg"; nw.alt = p.title; nw.src = v.img; swap.appendChild(nw);
          if (!reduce && old && old.animate) {
            old.animate([{ opacity: 1 }, { opacity: 0, transform: "scale(.92) rotate(-2deg)" }], { duration: 300, easing: "ease-in", fill: "forwards" });
            nw.animate([{ opacity: 0, transform: "scale(1.06) translateY(-10px)" }, { opacity: 1, transform: "none" }], { duration: 520, easing: "cubic-bezier(.22,1,.36,1)" });
          }
          setTimeout(() => { if (old && old.parentNode) old.remove(); }, reduce ? 0 : 320);
        }
      });
      const add = $("[data-add]", card);
      if (add) add.addEventListener("click", async () => {
        if (p.gustos) { abrirGustos(p, card._v, add); return; }
        const ok = await agregar([{ id: card._v.id, quantity: 1 }], add, "clasica", `${p.title} agregada`);
        if (ok) { add.classList.add("done"); setTimeout(() => add.classList.remove("done"), 1400); }
      });
    });
    pills();
  }

  /* ================= selector de gustos ================= */
  const sh = { p: null, v: null, flv: {}, from: null };
  const GUSTOS = () => DZ.gustos || [];
  const shCount = () => Object.values(sh.flv).reduce((s, n) => s + n, 0);
  function abrirGustos(p, v, from) {
    sh.p = p; sh.v = v; sh.from = from; sh.flv = Object.fromEntries(GUSTOS().map(g => [g.id, 0]));
    lastFocus = document.activeElement;
    $("#shSeg").innerHTML = '<span class="pill"></span>' + p.variants.map(x => `<button type="button" data-v="${x.id}" aria-pressed="${x.id === v.id}"${x.available ? "" : " disabled"}>${x.title}</button>`).join("");
    $("#shSeg").hidden = p.variants.length < 2;
    pintarGustos();
    $("#sheet").classList.add("on"); $("#sheet").setAttribute("aria-hidden", "false");
    $("#scrim").classList.add("on", "sh"); lock(true);
    setTimeout(() => { placePill($("#shSeg")); $("#shClose").focus(); }, 80);
  }
  function cerrarGustos() {
    $("#sheet").classList.remove("on"); $("#sheet").setAttribute("aria-hidden", "true");
    if (!$("#drawer").classList.contains("on")) { $("#scrim").classList.remove("on"); lock(false); }
    $("#scrim").classList.remove("sh");
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
  }
  function pintarGustos() {
    const n = sh.v.size, c = shCount();
    $("#shImg").src = sh.v.img || sh.p.img; $("#shImg").alt = `${sh.p.title}, ${sh.v.title}`;
    $("#shT").textContent = `${sh.p.title} · ${sh.v.title.toLowerCase()}`;
    $$("#shSeg button").forEach(b => b.setAttribute("aria-pressed", +b.dataset.v === sh.v.id));
    placePill($("#shSeg"));
    const fila = g => `<li class="${sh.flv[g.id] ? "has" : ""}"><span class="dz-dot" style="background:${g.color}"></span><span class="nm">${g.name}${g.extra ? `<small>+${money(g.extra)} c/u</small>` : ""}</span>
      <div class="qty"><button type="button" data-f="${g.id}" data-d="-1" aria-label="Una ${g.name} menos" ${sh.flv[g.id] ? "" : "disabled"}>−</button><span>${sh.flv[g.id]}</span><button type="button" data-f="${g.id}" data-d="1" aria-label="Una ${g.name} más" ${c >= n ? "disabled" : ""}>+</button></div></li>`;
    const base = GUSTOS().filter(g => !g.premium), prem = GUSTOS().filter(g => g.premium);
    $("#flv").innerHTML = base.map(fila).join("") + (prem.length ? `<li class="flv-sep">Premium</li>` + prem.map(fila).join("") : "");
    $("#shBar").style.width = (c / n * 100) + "%";
    const done = c === n;
    $("#shReq").textContent = done ? "Listo ✓" : `${c} de ${n}`;
    $("#shReq").classList.toggle("ok", done);
    const precio = sh.v.price + GUSTOS().reduce((s, g) => s + g.extra * sh.flv[g.id], 0);
    $("#shAdd").disabled = !done;
    $("#shAddTxt").textContent = done ? `Agregar · ${money(precio)}` : `Elige ${n - c} más`;
  }
  function iniciarGustos() {
    if (!$("#sheet")) return;
    $("#flv").addEventListener("click", e => {
      const b = e.target.closest("button[data-f]"); if (!b) return;
      const f = b.dataset.f, d = +b.dataset.d;
      if (d > 0 && shCount() >= sh.v.size) return;
      sh.flv[f] = Math.max(0, sh.flv[f] + d);
      pintarGustos();
      const nb = $(`#flv button[data-f="${f}"][data-d="${d}"]`), alt = $(`#flv button[data-f="${f}"][data-d="${-d}"]`);
      if (nb && !nb.disabled) nb.focus(); else if (alt && !alt.disabled) alt.focus(); else $("#shFill").focus();
    });
    $("#shSeg").addEventListener("click", e => {
      const b = e.target.closest("button[data-v]"); if (!b || b.disabled) return;
      sh.v = variante(sh.p, b.dataset.v);
      const orden = GUSTOS().slice().reverse();
      while (shCount() > sh.v.size) { const g = orden.find(x => sh.flv[x.id] > 0); sh.flv[g.id]--; }
      pintarGustos();
    });
    $("#shFill").addEventListener("click", () => {
      const base = GUSTOS().filter(g => !g.extra && !g.premium);
      if (!base.length) return;
      Object.keys(sh.flv).forEach(k => { sh.flv[k] = 0; });
      for (let k = 0; k < sh.v.size; k++) sh.flv[base[k % base.length].id]++;
      pintarGustos();
    });
    $("#shAdd").addEventListener("click", async () => {
      if (shCount() !== sh.v.size) return;
      const elegidos = GUSTOS().filter(g => sh.flv[g.id] > 0);
      const grupo = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      const items = [{ id: sh.v.id, quantity: 1, properties: { Gustos: elegidos.map(g => `${sh.flv[g.id]} ${g.name.toLowerCase()}`).join(", "), _grupo: grupo } }];
      elegidos.filter(g => g.recargo && g.extra).forEach(g => items.push({ id: g.recargo, quantity: sh.flv[g.id], properties: { _recargo: g.name, _grupo: grupo } }));
      const from = sh.from, p = sh.p, prem = elegidos.some(g => g.premium);
      cerrarGustos();
      const ok = await agregar(items, from, prem ? "pistacho" : "rellena", `${p.title} agregada`);
      if (ok && from) { from.classList.add("done"); setTimeout(() => from.classList.remove("done"), 1400); }
    });
    $("#shClose").addEventListener("click", cerrarGustos);
  }

  /* ================= para cuántos ================= */
  function iniciarPlanner() {
    $$("[data-dz-planner]").forEach(script => {
      let cfg; try { cfg = JSON.parse(script.textContent); } catch (e) { return; }
      const sec = script.closest("section");
      const P = cfg.productos || {};
      const MIX = { dulce: ["dulce1", "dulce2"], mixto: ["dulce1", "salado", "dulce2"], salado: ["salado"] };
      let ppl = 6, pref = "mixto";
      const tam = (p, n) => (p.variants || []).find(v => v.size === n && v.available);
      function plan() {
        const total = Math.max(6, Math.ceil(ppl * cfg.porPersona / 6) * 6);
        let lista = MIX[pref].filter(k => P[k]); if (!lista.length) lista = Object.keys(P).filter(k => P[k]);
        const cnt = {};
        for (let b = 0; b < total / 6; b++) { const k = lista[b % lista.length]; cnt[k] = (cnt[k] || 0) + 1; }
        const lines = [];
        Object.entries(cnt).forEach(([k, h]) => {
          const p = P[k], d12 = tam(p, 12), m6 = tam(p, 6);
          if (d12 && Math.floor(h / 2)) lines.push({ p, v: d12, qty: Math.floor(h / 2) });
          if (m6 && (h % 2 || !d12)) lines.push({ p, v: m6, qty: d12 ? 1 : h });
        });
        return { total, lines };
      }
      function pintar() {
        const { total, lines } = plan();
        $("[data-ppl-out]", sec).textContent = ppl;
        $('[data-ppl="-1"]', sec).disabled = ppl <= 1; $('[data-ppl="1"]', sec).disabled = ppl >= 60;
        $("[data-plan-units]", sec).textContent = `${total} medialunas`;
        $("[data-plan-list]", sec).innerHTML = lines.map(l => `<li><img class="thumb" src="${l.p.img}" alt="" width="64" height="44" loading="lazy"><span class="nm">${l.qty} × ${l.p.title}<small>${l.v.size === 6 ? "media docena" : "docena"}${l.p.gustos ? ` · mitad ${String(cfg.gustoMitad[0]).toLowerCase()}, mitad ${String(cfg.gustoMitad[1]).toLowerCase()}` : ""} · ${money(l.v.price)}</small></span><span class="num">${money(l.v.price * l.qty)}</span></li>`).join("");
        $("[data-plan-total]", sec).textContent = money(lines.reduce((s, l) => s + l.v.price * l.qty, 0));
      }
      sec.addEventListener("click", async e => {
        const s = e.target.closest("[data-ppl]"); if (s) { ppl = Math.min(60, Math.max(1, ppl + +s.dataset.ppl)); pintar(); return; }
        const c = e.target.closest("[data-pref]");
        if (c) { pref = c.dataset.pref; $$("[data-pref]", sec).forEach(x => x.setAttribute("aria-pressed", x === c)); pintar(); return; }
        const add = e.target.closest("[data-plan-add]");
        if (add) {
          const items = plan().lines.map(l => ({ id: l.v.id, quantity: l.qty, properties: l.p.gustos ? { Gustos: `${l.v.size / 2} ${String(cfg.gustoMitad[0]).toLowerCase()}, ${l.v.size / 2} ${String(cfg.gustoMitad[1]).toLowerCase()}`, _grupo: "plan" + Date.now().toString(36) } : {} }));
          await agregar(items, add, "clasica", "Pedido sugerido agregado");
        }
      });
      pintar();
    });
  }

  /* ================= historia ================= */
  function iniciarHistoria() {
    $$("[data-dz-historia]").forEach(h => {
      const svg = $("[data-st-svg]", h); if (!svg || !ML) return;
      const pasos = $$(".steps li", h), n = pasos.length;
      const dough = `<g><ellipse cx="0" cy="44" rx="96" ry="16" fill="url(#mlShadow)"/><path d="M-82 34 L82 34 L0 -58 Z" fill="url(#mlBakeRaw)" stroke="#B8955C" stroke-opacity=".5" stroke-width="1.5" stroke-linejoin="round"/>${[0.25, 0.45, 0.65, 0.82].map(k => `<path d="M${(-82 * (1 - k)).toFixed(1)} ${(34 - 92 * k).toFixed(1)} L${(82 * (1 - k)).toFixed(1)} ${(34 - 92 * k).toFixed(1)}" stroke="#C9A66E" stroke-opacity=".5" stroke-width="1.2"/>`).join("")}</g>`;
      const capas = [dough, ML.one({ variant: "clasica", seed: 11, raw: true }), ML.one({ variant: "clasica", seed: 11, gloss: 0 }), ML.one({ variant: "clasica", seed: 11, gloss: 1.3 }) + `<rect class="dz-shine" x="-140" y="-80" width="40" height="170" fill="url(#mlGloss)" opacity="0" transform="skewX(-20)"/>`];
      svg.innerHTML = capas.slice(0, Math.max(n, 1)).map((c, i) => `<g class="lyr" data-l="${i}" opacity="${i ? 0 : 1}">${c}</g>`).join("");
      let cur = -1;
      const set = i => {
        if (i === cur) return; cur = i;
        $$(".lyr", svg).forEach(g => g.setAttribute("opacity", +g.dataset.l === i ? 1 : 0));
        pasos.forEach(li => li.classList.toggle("on", +li.dataset.s === i));
        $$(".meter i", h).forEach((m, k) => m.classList.toggle("on", k <= i));
        $("[data-st-temp]", h).textContent = `Paso ${i + 1} de ${n} · ${(pasos[i].dataset.lbl || "").toLowerCase()}`;
        const shine = $(".dz-shine", svg);
        if (i === 3 && shine && !reduce && shine.animate) shine.animate([{ transform: "skewX(-20deg) translateX(0)", opacity: 0 }, { opacity: .9, offset: .3 }, { transform: "skewX(-20deg) translateX(320px)", opacity: 0 }], { duration: 1100, easing: "ease-in-out" });
      };
      set(0);
      if (!("IntersectionObserver" in window)) return;
      const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) set(+e.target.dataset.s); }), { rootMargin: "-45% 0px -45% 0px" });
      pasos.forEach(li => io.observe(li));
    });
  }

  /* ================= cabecera y menú ================= */
  const menuOpen = () => { const b = $("#menuBtn"); return b && b.getAttribute("aria-expanded") === "true"; };
  function cerrarMenu() {
    if (!menuOpen()) return;
    $("#menuBtn").setAttribute("aria-expanded", "false"); $("#menuBtn").setAttribute("aria-label", "Abrir menú");
    $("#mnav").hidden = true; $("#hdr").classList.remove("dz-menu-open");
  }
  function iniciarCabecera() {
    const h = $("#hdr"); if (!h) return;
    const mb = $("#menuBtn");
    mb.addEventListener("click", () => {
      if (menuOpen()) { cerrarMenu(); return; }
      mb.setAttribute("aria-expanded", "true"); mb.setAttribute("aria-label", "Cerrar menú");
      $("#mnav").hidden = false; h.classList.add("dz-menu-open"); h.classList.remove("hide");
    });
    $("#mnav").addEventListener("click", e => { if (e.target.closest("a")) cerrarMenu(); });
    document.addEventListener("click", e => { if (menuOpen() && !e.target.closest("#hdr")) cerrarMenu(); });
    window.addEventListener("resize", () => { if (window.innerWidth >= 960) cerrarMenu(); });
    const siempre = h.classList.contains("dz-siempre-solido");
    let last = window.scrollY, ticking = false;
    const on = () => {
      ticking = false;
      const y = window.scrollY;
      if (!siempre) h.classList.toggle("solid", y > 24);
      if (menuOpen()) { last = y; return; }
      if (y > 480 && y > last + 4 && !$("#drawer").classList.contains("on")) h.classList.add("hide");
      else if (y < last - 4 || y < 480) h.classList.remove("hide");
      last = y;
    };
    window.addEventListener("scroll", () => { if (!ticking) { ticking = true; requestAnimationFrame(on); } }, { passive: true });
    on();
  }

  /* ================= animaciones ================= */
  function iniciarParallax() {
    if (reduce || !fine) return;
    const els = $$("[data-dz-parallax]"), pol = $("[data-dz-polaroid]");
    if (!els.length && !pol) return;
    let ticking = false;
    const run = () => {
      ticking = false;
      if (window.innerWidth < 960) { els.forEach(el => { el.style.transform = ""; }); if (pol) pol.style.transform = ""; return; }
      const y = window.scrollY;
      if (y < window.innerHeight * 1.2) els.forEach(el => { el.style.transform = `translate3d(0,${(y * +el.dataset.dzParallax).toFixed(1)}px,0)`; });
      if (pol) {
        const r = pol.closest("section").getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) { const p = 1 - (r.top + r.height) / (window.innerHeight + r.height); pol.style.transform = `translate3d(0,${(40 - p * 80).toFixed(1)}px,0) rotate(${(-3 + p * 6).toFixed(2)}deg)`; }
      }
    };
    window.addEventListener("scroll", () => { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }
  function iniciarApariciones() {
    if (reduce || !("IntersectionObserver" in window) || document.documentElement.classList.contains("shopify-design-mode")) return;
    const grupos = [[".dz .sec-head", "> *", "", .08], [".dz .dz-grid", ".dz-card", "rv-s", .08], [".dz .planner", "", "", 0], [".dz .how", "li", "", .1], [".dz .apps", "", "", 0], [".dz .local", "> *", "rv-s", .1], [".dz .faq", "details", "", .06], [".dz .final-copy", "> *", "", .08], [".dz .polaroid", "", "rv-s", 0], [".dz .ig-strip", "a", "rv-s", .06]];
    const els = [];
    grupos.forEach(([r, s, cls, st]) => $$(r).forEach(root => {
      const kids = !s ? [root] : s.startsWith(">") ? Array.from(root.children) : $$(s, root);
      kids.forEach((k, i) => { if (k.classList.contains("rv")) return; k.classList.add("rv"); if (cls) k.classList.add(cls); k.style.setProperty("--d", Math.min(i * st, .5).toFixed(2) + "s"); els.push(k); });
    }));
    const io = new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting || e.boundingClientRect.top < 0) { e.target.classList.add("in"); setTimeout(() => e.target.style.removeProperty("--d"), 1600); io.unobserve(e.target); }
    }), { rootMargin: "0px 0px -6% 0px", threshold: 0 });
    els.forEach(k => io.observe(k));
  }
  function iniciarPreguntas() {
    $$(".dz .faq details").forEach(d => {
      const s = $("summary", d), a = $(".ans", d); let busy = false;
      s.addEventListener("click", e => {
        if (reduce || !a.animate) return;
        e.preventDefault(); if (busy) return; busy = true;
        if (d.open) { const h = a.offsetHeight; a.animate([{ height: h + "px", opacity: 1 }, { height: "0px", opacity: 0 }], { duration: 320, easing: "cubic-bezier(.65,0,.35,1)" }).onfinish = () => { d.open = false; busy = false; }; }
        else { d.open = true; const h = a.offsetHeight; a.animate([{ height: "0px", opacity: 0 }, { height: h + "px", opacity: 1 }], { duration: 420, easing: "cubic-bezier(.22,1,.36,1)" }).onfinish = () => { busy = false; }; }
      });
    });
  }

  /* ================= página con contraseña ================= */
  function iniciarCortina() {
    const eye = $("#gateEye"), input = $("#gatePass"); if (!eye || !input) return;
    const form = $("#gateForm"), go = $("#gateGo");
    const ancho = () => form.style.setProperty("--go-w", go.offsetWidth + "px");
    ancho(); window.addEventListener("resize", ancho); if (document.fonts) document.fonts.ready.then(ancho);
    eye.addEventListener("click", () => { const show = input.type === "password"; input.type = show ? "text" : "password"; eye.setAttribute("aria-pressed", String(show)); eye.setAttribute("aria-label", show ? "Ocultar clave" : "Mostrar clave"); input.focus(); });
    if ($("#gateMsg").textContent.trim()) { form.classList.add("shake"); input.focus(); }
    form.addEventListener("submit", () => { go.disabled = true; $("span", go).textContent = "Revisando…"; });
  }

  /* ================= arranque ================= */
  function iniciar() {
    ilustraciones(document);
    pintarHorario(); setInterval(pintarHorario, 60000);
    iniciarCabecera();
    iniciarCarta();
    iniciarGustos();
    iniciarPlanner();
    iniciarHistoria();
    iniciarParallax();
    iniciarApariciones();
    iniciarPreguntas();
    iniciarCortina();
    if ($("#drawer")) {
      $("#cartBtn").addEventListener("click", abrirPedido);
      $("#mbarBtn").addEventListener("click", abrirPedido);
      $("#drClose").addEventListener("click", cerrarPedido);
      $("#emptyGo").addEventListener("click", cerrarPedido);
      $("#scrim").addEventListener("click", () => { if ($("#sheet").classList.contains("on")) cerrarGustos(); else cerrarPedido(); });
      $("#items").addEventListener("click", e => { const b = e.target.closest("[data-q]"); if (b) cambiarCaja(b.closest(".item").dataset.key, +b.dataset.q); });
      $("#payBtn").addEventListener("click", irAPagar);
      cargarCarrito().catch(() => {});
    }
    document.addEventListener("keydown", e => {
      const sheetOn = $("#sheet") && $("#sheet").classList.contains("on"), drawerOn = $("#drawer") && $("#drawer").classList.contains("on");
      if (e.key === "Escape") { if (sheetOn) { cerrarGustos(); return; } if (drawerOn) { cerrarPedido(); return; } if (menuOpen()) { cerrarMenu(); $("#menuBtn").focus(); } }
      if (e.key === "Tab" && (sheetOn || drawerOn)) {
        const box = sheetOn ? $("#sheet") : $("#drawer");
        const f = $$("button:not([disabled]), a[href], input, select, textarea", box).filter(x => x.offsetParent !== null);
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    window.addEventListener("resize", pills);
    if (document.fonts) document.fonts.ready.then(pills);
    // el editor de temas recarga secciones sueltas: volver a pintar ilustraciones y carta
    document.addEventListener("shopify:section:load", e => { ilustraciones(e.target); iniciarCarta(); iniciarPlanner(); iniciarHistoria(); pintarHorario(); });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", iniciar); else iniciar();
})();
